// extracted by mini-css-extract-plugin
export default {"container":"src-components-CloneButton-css-module__container--ASi4q","btn":"src-components-CloneButton-css-module__btn--2YzhK"};